module.exports = __webpack_public_path__ + "img/1.873f7b06.jpg";